import React, { useState, useEffect } from "react";
import "./LeaveApplicationHODTable.css";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { RingLoader } from "react-spinners";
import { css } from "@emotion/react";
import { Form, Button, Col, Row } from "react-bootstrap";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

const override = css`
  display: block;
  margin: 0 auto;
  margin-top: 45px;
  border-color: red;
`;

export default function LeaveApplicationHODTable(props) {
  const [leaveApplicationHODData, setLeaveApplicationHODData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchData, setSearchData] = useState("");
  const [rowData, setRowData] = useState([]);
  const renderButton = (params) => {
    // console.log(params);
    return (
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() =>
          onLeaveApplicationHODDelete(
            params.data.data["employee"][0]["_id"],
            params.data.data["_id"]
          )
        }
      />
    );
  };
  const renderEditButton = (params) => {
    // console.log(params);
    return (
      <FontAwesomeIcon
        icon={faEdit}
        onClick={() => props.onEditLeaveApplicationHOD(params.data)}
      />
    );
  };

  const columnDefs = [
    {
      headerName: "Leave type",
      field: "Leavetype",
      sortable: true,
      // filter: true ,
    },
    {
      headerName: "From Date",
      field: "FromDate",
      sortable: true,
      filter: true,
      // type: ["dateColumn"],
    },
    {
      headerName: "To Date",
      field: "ToDate",
      sortable: true,
      filter: true,
      // type: ["dateColumn"],
    },
    {
      headerName: "Reason",
      field: "Reasonforleave",
      sortable: true,
      // filter: true ,
    },
    {
      headerName: "Status",
      field: "Status",
      sortable: true,
      // filter: true ,
    },

    {
      headerName: "",
      field: "edit",
      filter: false,
      width: 30,
      cellRendererFramework: renderEditButton,
    },
  ];

  const defaultColDef = {
    resizable: true,
    width: 170,
    filter: "agTextColumnFilter",
    // filter: true ,
  };
  const getRowHeight = 35;

  const loadLeaveApplicationHODData = () => {
    axios
      .get(
        "https://almawridems.javedahmadghamidi.com" +
          "/api/ems/leave-and-monthlyreport-hod/" +
          localStorage.getItem("department"),
        {
          headers: {
            authorization: localStorage.getItem("token") || "",
          },
        }
      )
      .then((response) => {
        // console.log(response.data);
        setLeaveApplicationHODData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const onLeaveApplicationHODDelete = (e1, e2) => {
    // console.log(e1, e2);
    if (window.confirm("Are you sure to delete this record? ") === true) {
      axios
        .delete(
          "https://almawridems.javedahmadghamidi.com" +
            "/api/ems/leave-application-hod/" +
            e1 +
            "/" +
            e2,
          {
            headers: {
              authorization: localStorage.getItem("token") || "",
            },
          }
        )
        .then((res) => {
          loadLeaveApplicationHODData();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  useEffect(() => {
    loadLeaveApplicationHODData();
  }, []);
  const SelectedEmp = (e) => {
    leaveApplicationHODData.forEach((data) => {
      if (data._id == e) {
        let rowDataT = [];
        // let data=this.educationObj.education["0"];
        data["leaveApplication"].map((data) => {
          let temp = {
            data,
            Leavetype: data["Leavetype"],
            FromDate: data["FromDate"].slice(0, 10),
            ToDate: data["ToDate"].slice(0, 10),
            Reasonforleave: data["Reasonforleave"],
            Status: data["Status"],
          };
          rowDataT.push(temp);
        });
        setRowData(rowDataT);
      }
    });
  };

  return (
    <div id="table-outer-div-scroll">
      <h2 id="role-title">Employee Leave Application Details</h2>
      <Form.Group as={Row} className="mr-md-2 ml-md-2">
        <Form.Label column sm={2}>
          Employee
        </Form.Label>
      </Form.Group>

      {leaveApplicationHODData.map(
        (data, index) =>
          data["leaveApplication"].length > 0 && (
            <Button
              style={{ margin: "10px" }}
              key={index}
              onClick={() => SelectedEmp(data["_id"])}>
              {data["FirstName"] +
                " " +
                data["LastName"] +
                " (" +
                data["leaveApplication"].length +
                " Applications)"}
            </Button>
          )
      )}

      <div id="clear-both" />
      {!loading ? (
        <div id="table-div" className="ag-theme-balham">
          {rowData.length > 0 && (
            <AgGridReact
              columnDefs={columnDefs}
              defaultColDef={defaultColDef}
              rowData={rowData}
              pagination={true}
              paginationPageSize={10}
              getRowHeight={getRowHeight}
            />
          )}
        </div>
      ) : (
        <div id="loading-bar">
          <RingLoader
            css={override}
            sizeUnit={"px"}
            size={50}
            color={"#0000ff"}
            loading={true}
          />
        </div>
      )}
    </div>
  );
}
